import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import AboutUs from './components/AboutUs';
import Services from './components/Services';
import Footer from './components/Footer';
import HomePage from './components/Home';
import ChatWidget from './components/ChatWIdget';


interface AppProps {}

const App: React.FC<AppProps> = () => {
  return (
    <BrowserRouter>
          <Navbar />
          <Routes>
            <Route path="/" element={<HomePage />} /> 
            <Route path="/aboutUs" element={<AboutUs />} />  
            <Route path="/services" element={<Services />} /> 
          </Routes>
          <Footer />
          <ChatWidget />
    </BrowserRouter>
  );
};

export default App;